import { render, staticRenderFns } from "./Anagrafica.vue?vue&type=template&id=0c623867&"
import script from "./Anagrafica.vue?vue&type=script&lang=js&"
export * from "./Anagrafica.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports